import { Pipe, PipeTransform } from '@angular/core';
import { LearningResource } from '../models/learningResource';
import * as _ from 'lodash';

@Pipe({
    name: 'learningResourcesSort',
    pure: false,
    standalone: false
})
export class LearningResourcesSortPipe implements PipeTransform {
    transform(items: LearningResource[], sort: any): any[] {
        if (!items) {
            return items;
        }

        if(sort){
            if(sort === 'recent')
                items = _.orderBy(items, 'CreatedOn', ['desc']);
            if(sort === 'name')
                items = _.orderBy(items, [items => items.Name?.toLowerCase()]);
            if(sort === 'org')
                items = _.orderBy(items, [items => items.AuthorOrganization?.toLowerCase()]);
        }

        return items;
    }
}
